module.exports = __webpack_public_path__ + "media/profile_pictures/profile-picture-1-cc357aba.jpg";